export default async function getCurrentSeasonStats(sportId: number, stats?: any) {
  let statsData = stats;

  // If stats not provided, fetch from API
  if (!statsData) {
    const res = await fetch('/api/v1/release/stats');
    statsData = await res.json();
  }

  if (!statsData?.seasonId) {
    return null;
  }

  // Find all seasons for the given sportId
  const seasons = Object.values(statsData.seasonId).filter((season: any) => {
    // meta.season can be an object with keys, so get the first value
    const metaSeasonObj = season.meta?.season;
    const metaSeason =
      metaSeasonObj && typeof metaSeasonObj === 'object'
        ? Object.values(metaSeasonObj)[0]
        : undefined;
    return metaSeason?.sportId === sportId;
  });

  if (!seasons.length) {
    return null;
  }

  // Sort by startDate descending to get the most recent/current season
  seasons.sort((a: any, b: any) => {
    const aMetaSeasonObj = a.meta?.season;
    const bMetaSeasonObj = b.meta?.season;
    const aMetaSeason =
      aMetaSeasonObj && typeof aMetaSeasonObj === 'object'
        ? Object.values(aMetaSeasonObj)[0]
        : undefined;
    const bMetaSeason =
      bMetaSeasonObj && typeof bMetaSeasonObj === 'object'
        ? Object.values(bMetaSeasonObj)[0]
        : undefined;
    const aDate = Date.parse(aMetaSeason?.startDate || '');
    const bDate = Date.parse(bMetaSeason?.startDate || '');
    return bDate - aDate;
  });

  // The most recent season is the first after sorting
  const currentSeason = seasons[0];

  return currentSeason || null;
}
